import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

const state = {
    controls: [],
    coupons: [],
    search: null,
    pagination: null
};

const getters = {
    controls: state => state.controls,
    coupons: state => state.coupons,
    search: state => state.search,
    pagination: state => state.pagination
};

const mutations = {
    setControls: (state, data) => state.controls = data,
    setCoupons: (state, data) => state.coupons = data,
    setSearch: (state, data) => state.search = data,
    setPagination: (state, data) => state.pagination = data
};

const actions = {
    getData: async (context, data) => {
        let response = await Axios.post("/voucher-coupon/api/modulelist/getdata?nav=" + data.nav);

        let controls = response.data.controls;

        FormHelper.initRuntimeProperties(controls);

        context.commit("setControls", controls);
        context.commit("setCoupons", response.data.coupons);
        context.commit("setSearch", response.data.search);
        context.commit("setPagination", response.data.pagination);

        return response;
    },
    getCoupon: async (context, data) => {
        return await Axios.post("/voucher-coupon/api/modulelist/getcoupon?nav=" + data.nav, data);
    },
    saveCoupon: async (context, data) => {
        return await Axios.post("/voucher-coupon/api/modulelist/savecoupon?nav=" + data.nav, data);
    },
    removeCoupon: async (context, data) => {
        return await Axios.post("/voucher-coupon/api/modulelist/removecoupon?nav=" + data.nav, data);
    },
    getSearchSuggestions: async (context, data) => {
        return await Axios.post("/voucher-coupon/api/modulelist/getsearchsuggestions?nav=" + data.nav, data);
    },
    setSearch: async (context, data) => {
        return await Axios.put("/voucher-coupon/api/modulelist/setsearch?nav=" + data.nav, data);
    },
    setPageIndex: async (context, data) => {
        return await Axios.put("/voucher-coupon/api/modulelist/setpageindex?nav=" + data.nav, data);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};